"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdKitAdDismissAffordance = exports.AdKitVideoAssetOption = exports.AdKitFeatureFlags_VideoAssetOptionsEntry = exports.AdKitFeatureFlags = exports.AdKitEndCardAffordance = exports.AdKitWebBrowserType = exports.AdKitEmbeddedAdStyle = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../google/protobuf/wrappers");
var AdKitEmbeddedAdStyle;
(function (AdKitEmbeddedAdStyle) {
    AdKitEmbeddedAdStyle[AdKitEmbeddedAdStyle["NOT_ELIGIBLE"] = 0] = "NOT_ELIGIBLE";
    AdKitEmbeddedAdStyle[AdKitEmbeddedAdStyle["DEFAULT"] = 1] = "DEFAULT";
    /**
     * TRANSPARENT_CARD_PURPLE_BUTTON - Style with a purple action button and transparent background
     * https://www.figma.com/file/xK4jQeTBh0k7Tiidqe6PRt/Dubsmash-Ads?node-id=1%3A7
     */
    AdKitEmbeddedAdStyle[AdKitEmbeddedAdStyle["TRANSPARENT_CARD_PURPLE_BUTTON"] = 2] = "TRANSPARENT_CARD_PURPLE_BUTTON";
    /** GRAY_TOP_BAR_BLUE_BUTTON - Style with a gray top bar (nav bar) and a blue action button */
    AdKitEmbeddedAdStyle[AdKitEmbeddedAdStyle["GRAY_TOP_BAR_BLUE_BUTTON"] = 3] = "GRAY_TOP_BAR_BLUE_BUTTON";
    AdKitEmbeddedAdStyle[AdKitEmbeddedAdStyle["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AdKitEmbeddedAdStyle = exports.AdKitEmbeddedAdStyle || (exports.AdKitEmbeddedAdStyle = {}));
var AdKitWebBrowserType;
(function (AdKitWebBrowserType) {
    AdKitWebBrowserType[AdKitWebBrowserType["WEB_BROWSER_V11"] = 0] = "WEB_BROWSER_V11";
    AdKitWebBrowserType[AdKitWebBrowserType["SAFARI"] = 1] = "SAFARI";
    AdKitWebBrowserType[AdKitWebBrowserType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AdKitWebBrowserType = exports.AdKitWebBrowserType || (exports.AdKitWebBrowserType = {}));
var AdKitEndCardAffordance;
(function (AdKitEndCardAffordance) {
    AdKitEndCardAffordance[AdKitEndCardAffordance["END_CARD_NONE"] = 0] = "END_CARD_NONE";
    AdKitEndCardAffordance[AdKitEndCardAffordance["END_CARD_FULL_IMMEDIATE"] = 1] = "END_CARD_FULL_IMMEDIATE";
    AdKitEndCardAffordance[AdKitEndCardAffordance["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AdKitEndCardAffordance = exports.AdKitEndCardAffordance || (exports.AdKitEndCardAffordance = {}));
function createBaseAdKitFeatureFlags() {
    return {
        shouldDisableAds: false,
        endCardAffordance: 0,
        adkitDismissAffordance: undefined,
        shouldEnableBolt: false,
        boltStreamingThresholdMs: undefined,
        adkitRewardedDismissAffordance: undefined,
        skAdNetworkVersion: "",
        embeddedAdStyle: 0,
        webBrowserType: 0,
        videoAssetOptions: {},
        shouldEnableGraphene: false,
        grapheneSamplingPercentage: undefined,
        shouldEnableHeaderBidding: false,
        smallFormatLocalization: false,
        shouldDisableCof: false,
        crashReportingDisabled: false,
        shouldDisableCofPersistence: false,
    };
}
exports.AdKitFeatureFlags = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.shouldDisableAds === true) {
            writer.uint32(8).bool(message.shouldDisableAds);
        }
        if (message.endCardAffordance !== 0) {
            writer.uint32(16).int32(message.endCardAffordance);
        }
        if (message.adkitDismissAffordance !== undefined) {
            exports.AdKitAdDismissAffordance.encode(message.adkitDismissAffordance, writer.uint32(26).fork()).ldelim();
        }
        if (message.shouldEnableBolt === true) {
            writer.uint32(32).bool(message.shouldEnableBolt);
        }
        if (message.boltStreamingThresholdMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.boltStreamingThresholdMs }, writer.uint32(42).fork()).ldelim();
        }
        if (message.adkitRewardedDismissAffordance !== undefined) {
            exports.AdKitAdDismissAffordance.encode(message.adkitRewardedDismissAffordance, writer.uint32(50).fork()).ldelim();
        }
        if (message.skAdNetworkVersion !== "") {
            writer.uint32(58).string(message.skAdNetworkVersion);
        }
        if (message.embeddedAdStyle !== 0) {
            writer.uint32(64).int32(message.embeddedAdStyle);
        }
        if (message.webBrowserType !== 0) {
            writer.uint32(72).int32(message.webBrowserType);
        }
        Object.entries(message.videoAssetOptions).forEach(([key, value]) => {
            exports.AdKitFeatureFlags_VideoAssetOptionsEntry.encode({ key: key, value }, writer.uint32(82).fork()).ldelim();
        });
        if (message.shouldEnableGraphene === true) {
            writer.uint32(88).bool(message.shouldEnableGraphene);
        }
        if (message.grapheneSamplingPercentage !== undefined) {
            wrappers_1.UInt32Value.encode({ value: message.grapheneSamplingPercentage }, writer.uint32(98).fork()).ldelim();
        }
        if (message.shouldEnableHeaderBidding === true) {
            writer.uint32(104).bool(message.shouldEnableHeaderBidding);
        }
        if (message.smallFormatLocalization === true) {
            writer.uint32(112).bool(message.smallFormatLocalization);
        }
        if (message.shouldDisableCof === true) {
            writer.uint32(120).bool(message.shouldDisableCof);
        }
        if (message.crashReportingDisabled === true) {
            writer.uint32(128).bool(message.crashReportingDisabled);
        }
        if (message.shouldDisableCofPersistence === true) {
            writer.uint32(136).bool(message.shouldDisableCofPersistence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdKitFeatureFlags();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.shouldDisableAds = reader.bool();
                    break;
                case 2:
                    message.endCardAffordance = reader.int32();
                    break;
                case 3:
                    message.adkitDismissAffordance = exports.AdKitAdDismissAffordance.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.shouldEnableBolt = reader.bool();
                    break;
                case 5:
                    message.boltStreamingThresholdMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.adkitRewardedDismissAffordance =
                        exports.AdKitAdDismissAffordance.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.skAdNetworkVersion = reader.string();
                    break;
                case 8:
                    message.embeddedAdStyle = reader.int32();
                    break;
                case 9:
                    message.webBrowserType = reader.int32();
                    break;
                case 10:
                    const entry10 = exports.AdKitFeatureFlags_VideoAssetOptionsEntry.decode(reader, reader.uint32());
                    if (entry10.value !== undefined) {
                        message.videoAssetOptions[entry10.key] = entry10.value;
                    }
                    break;
                case 11:
                    message.shouldEnableGraphene = reader.bool();
                    break;
                case 12:
                    message.grapheneSamplingPercentage = wrappers_1.UInt32Value.decode(reader, reader.uint32()).value;
                    break;
                case 13:
                    message.shouldEnableHeaderBidding = reader.bool();
                    break;
                case 14:
                    message.smallFormatLocalization = reader.bool();
                    break;
                case 15:
                    message.shouldDisableCof = reader.bool();
                    break;
                case 16:
                    message.crashReportingDisabled = reader.bool();
                    break;
                case 17:
                    message.shouldDisableCofPersistence = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdKitFeatureFlags();
        message.shouldDisableAds = object.shouldDisableAds ?? false;
        message.endCardAffordance = object.endCardAffordance ?? 0;
        message.adkitDismissAffordance =
            object.adkitDismissAffordance !== undefined &&
                object.adkitDismissAffordance !== null
                ? exports.AdKitAdDismissAffordance.fromPartial(object.adkitDismissAffordance)
                : undefined;
        message.shouldEnableBolt = object.shouldEnableBolt ?? false;
        message.boltStreamingThresholdMs =
            object.boltStreamingThresholdMs ?? undefined;
        message.adkitRewardedDismissAffordance =
            object.adkitRewardedDismissAffordance !== undefined &&
                object.adkitRewardedDismissAffordance !== null
                ? exports.AdKitAdDismissAffordance.fromPartial(object.adkitRewardedDismissAffordance)
                : undefined;
        message.skAdNetworkVersion = object.skAdNetworkVersion ?? "";
        message.embeddedAdStyle = object.embeddedAdStyle ?? 0;
        message.webBrowserType = object.webBrowserType ?? 0;
        message.videoAssetOptions = Object.entries(object.videoAssetOptions ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.AdKitVideoAssetOption.fromPartial(value);
            }
            return acc;
        }, {});
        message.shouldEnableGraphene = object.shouldEnableGraphene ?? false;
        message.grapheneSamplingPercentage =
            object.grapheneSamplingPercentage ?? undefined;
        message.shouldEnableHeaderBidding =
            object.shouldEnableHeaderBidding ?? false;
        message.smallFormatLocalization = object.smallFormatLocalization ?? false;
        message.shouldDisableCof = object.shouldDisableCof ?? false;
        message.crashReportingDisabled = object.crashReportingDisabled ?? false;
        message.shouldDisableCofPersistence =
            object.shouldDisableCofPersistence ?? false;
        return message;
    },
};
function createBaseAdKitFeatureFlags_VideoAssetOptionsEntry() {
    return { key: "", value: undefined };
}
exports.AdKitFeatureFlags_VideoAssetOptionsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.AdKitVideoAssetOption.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdKitFeatureFlags_VideoAssetOptionsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = exports.AdKitVideoAssetOption.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdKitFeatureFlags_VideoAssetOptionsEntry();
        message.key = object.key ?? "";
        message.value =
            object.value !== undefined && object.value !== null
                ? exports.AdKitVideoAssetOption.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseAdKitVideoAssetOption() {
    return { values: undefined };
}
exports.AdKitVideoAssetOption = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.values?.$case === "stringValue") {
            writer.uint32(10).string(message.values.stringValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdKitVideoAssetOption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.values = {
                        $case: "stringValue",
                        stringValue: reader.string(),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdKitVideoAssetOption();
        if (object.values?.$case === "stringValue" &&
            object.values?.stringValue !== undefined &&
            object.values?.stringValue !== null) {
            message.values = {
                $case: "stringValue",
                stringValue: object.values.stringValue,
            };
        }
        return message;
    },
};
function createBaseAdKitAdDismissAffordance() {
    return {
        shouldEnableDismissDelay: false,
        dismissDelaySeconds: undefined,
        endcardDismissDelaySeconds: undefined,
    };
}
exports.AdKitAdDismissAffordance = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.shouldEnableDismissDelay === true) {
            writer.uint32(8).bool(message.shouldEnableDismissDelay);
        }
        if (message.dismissDelaySeconds !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.dismissDelaySeconds }, writer.uint32(18).fork()).ldelim();
        }
        if (message.endcardDismissDelaySeconds !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.endcardDismissDelaySeconds }, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdKitAdDismissAffordance();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.shouldEnableDismissDelay = reader.bool();
                    break;
                case 2:
                    message.dismissDelaySeconds = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.endcardDismissDelaySeconds = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdKitAdDismissAffordance();
        message.shouldEnableDismissDelay = object.shouldEnableDismissDelay ?? false;
        message.dismissDelaySeconds = object.dismissDelaySeconds ?? undefined;
        message.endcardDismissDelaySeconds =
            object.endcardDismissDelaySeconds ?? undefined;
        return message;
    },
};
//# sourceMappingURL=ad_kit_feature_flags.js.map